/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/ScriptConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ScriptConfigCardTestIds = {
  btnCreateScriptConfig: "btn-create-script-config",
  btnEditScriptConfig: "btn-edit-script-config",
  btnValidateScript: "btn-validate-script",
  cardTitleScriptConfig: "card-title-script-config",
  scriptConfigCard: "script-config-card",
  badgeOp: (key_toLowerCase: string) => `badge-op-${key_toLowerCase}`,
  badgeOpPrefix: () => "badge-op-" as TestIdPrefix,
  badgeOpDisplay: (key_toLowerCase: string) => `badge-op-display-${key_toLowerCase}`,
  badgeOpDisplayPrefix: () => "badge-op-display-" as TestIdPrefix,
  switchOp: (key_toLowerCase: string) => `switch-op-${key_toLowerCase}`,
  switchOpPrefix: () => "switch-op-" as TestIdPrefix
} as const;
